import { render } from "./NewSMSForm.vue?vue&type=template&id=21e51a54"
import script from "./NewSMSForm.vue?vue&type=script&lang=js"
export * from "./NewSMSForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__